import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";

const AdminLogin = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      navigate("/admin", { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <Logo light className="text-2xl inline-block" />
        </div>
        <div className="bg-white p-10 border border-slate-200">
          <div className="flex items-center gap-3 mb-8">
            <Lock size={22} className="text-gold" />
            <h1 className="text-xl font-medium text-navy">Admin Sign In</h1>
          </div>
          <form data-testid="admin-login-form" onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                data-testid="admin-login-email"
                className="w-full border-b border-slate-300 bg-transparent py-3 text-navy focus:border-gold focus:outline-none transition-colors"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-600 mb-1" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                data-testid="admin-login-password"
                className="w-full border-b border-slate-300 bg-transparent py-3 text-navy focus:border-gold focus:outline-none transition-colors"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={loading}
              className="w-full bg-navy text-white hover:bg-navy-light transition-colors duration-200 py-3.5 text-sm font-semibold tracking-wide disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
